/**
 * Scroll To Top Component - Alpine.js
 *
 * Global scroll-to-top button with smooth animations.
 * Automatically shows/hides based on scroll position.
 *
 * Usage in template:
 * <div x-data="scrollToTop">
 *   <button @click="scrollUp()" x-show="visible" x-transition>
 *     Scroll to top
 *   </button>
 * </div>
 */

export default () => ({
  visible: false,
  scrollThreshold: 300,

  init() {
    // Watch scroll position
    window.addEventListener('scroll', () => this.checkScroll());
    this.checkScroll();
  },

  checkScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.visible = scrollTop > this.scrollThreshold;
  },

  scrollUp() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  },
});
